<template>
  <status-modal-fail>
    <template #title>
      {{ $t('WithdrawToWallet | failModalHeader') }}
    </template>

    <template #description>
      {{ $t(errorCode) }}
    </template>

    <template #actions>
      <base-button
        type="cta"
        size="lg"
        data-cy="withdraw-to-card-fail-repeat"
        @onClick="$emit('repeat-withdraw')"
      >
        {{ $t('WithdrawToCard | actionRepeatFailedWithdraw') }}
      </base-button>
      <base-button
        type="shade"
        size="lg"
        data-cy="withdraw-to-card-fail-go-to-support"
        @onClick="openChat"
      >
        {{ $t('WithdrawToCard | actionGoToSupport') }}
      </base-button>
    </template>
  </status-modal-fail>
</template>

<script setup>
import AnalyticsService from '@emcd-shared/analytics-service'
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import { StatusModalFail } from '@/shared/ui/StatusModalFail'

// eslint-disable-next-line vue/no-setup-props-destructure
const { errorCode } = defineProps(['errorCode'])

const emit = defineEmits(['repeat-withdraw'])

function openChat() {
  AnalyticsService.install()
  AnalyticsService.init()
  AnalyticsService.openDialogue()
  emit('close')
}
</script>
